<template>
  <div class="mainPage">
    <div class="header_banner">
      <img src="../img/chineseCultureVideoExhibition/2026/pc/header.png" alt="央视精品节目展播" class="banner_img" />
    </div>
    <div class="main_content" ref="mainContent">
      <!-- 课程目录 -->
      <div class="course_index left_content" ref="CourseIndex">
        <div :class="['index_item', { 'active': index == activeNavIndex }]" v-for="(program, index) in subject_info"
          :key="program.id" :id="'index-' + program.id" @click="scrollToProgram(index)">
          <p class="name">{{ program.name }}</p>
          <p class="name_en">{{ program.name_en }}</p>
        </div>
      </div>
      <!-- 主题介绍 -->
      <div class="right_content">
        <div class="theme_intro" ref="pcThemeIntro">
          <div class="theme_intro_cn">
            在第十七个联合国中文日到来之际，我们将面向海外中文学习者及中国文化爱好者，特别推出2026“魅力中文”联合国中文日展播，带您欣赏中央广播电视总台制作的精品节目。在微短剧《舞动敦煌》《墨韵新生》《顾盼锦年》中，感受中华传统艺术的灵动与新生；在《成语探华夏》《“字”从遇见你》（第三季）、“中文轻松学”融媒体汉语教学节目中，发现学习中文的乐趣；在《中国民间故事》《远方的童谣》《传世古建》《中华考工记》《宗师列传·大唐诗人传》《简牍探中华》（第二季）中，沉浸式体验中华文化的多元魅力。
          </div>
          <div class="theme_intro_en">
            On the occasion of the 17th United Nations Chinese Language Day, we will specially launch the 2026 "Charming
            Chinese" UN Chinese Language Day Screening Series around April 20 for overseas Chinese language learners and
            Chinese culture enthusiasts, presenting a selection of high-quality programs produced by China Media Group
            (CMG).In the short dramas Dunhuang in Motion, Ink Rhythm Reborn and Glances Through Splendid Years, you will
            feel the dynamism and revitalization of traditional Chinese art.In Idioms Uncover China, The Story of
            Characters
            (Season 3) and the integrated media Chinese learning program "Easy Chinese", you will discover the joy of
            learning Chinese.In Chinese Folktales, Distant Nursery Rhymes, Timeless Ancient Architecture, Chinese Crafts
            in
            Time, Biographies of Great Masters: Poets of the Tang Dynasty and Bamboo and Wooden Slips: Exploring China
            (Season 2), you can immerse yourself in the diverse splendor of Chinese culture.
          </div>
        </div>
        <div class="core_content" ref="CourseContainer">
          <div class="program_box" v-for="(program, index) in subject_info" :key="program.id">
            <div class="series_info">
              <div class="cloud_con">
                <div class="serise_icon_con">
                  <img :src="program.image_url" :alt="program.name" />
                </div>
                <div class="name_con">
                  <p class="cn">{{ program.name }}</p>
                  <p class="en">{{ program.name_en }}</p>
                </div>
              </div>
              <div class="look_detail_icon" @click="goDetail(program, 0)">
              </div>
            </div>
            <template v-if="program.courseList && program.courseList.length > 1">
              <div class="description">
                <div class="text_cn" v-if="
                  program.courseList &&
                  program.courseList[0] &&
                  program.courseList[0].describe
                ">
                  {{ program.courseList[0].describe }}
                </div>
                <div class="text_en" v-if="
                  program.courseList &&
                  program.courseList[0] &&
                  program.courseList[0].describe_en
                ">
                  {{ program.courseList[0].describe_en }}
                </div>
              </div>
              <div class="swiper_con">
                <swiper :options="swiperOption" ref="mySwiper" class="swiper">
                  <swiper-slide v-for="(v, _i) in program.courseList" :key="_i" style="width: 3.5rem;">
                    <div class="video_con" :data-info="v.name" @click="goDetail(program, _i)">
                      <div class="video_cover">
                        <img :src="v.cover_url" :alt="v.name" class="cover" />
                      </div>
                      <div class="titleBox">
                        <div class="course_title">
                          <div class="cn">{{ v.name }}</div>
                          <div class="en">{{ v.name_en }}</div>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                  <div class="swiper-button-prev" slot="button-prev"
                    v-show="program.courseList && program.courseList.length > 3"></div>
                  <div class="swiper-button-next" slot="button-next"
                    v-show="program.courseList && program.courseList.length > 3"></div>
                </swiper>
              </div>
            </template>
            <template v-else>
              <div class="simple_content">
                <div class="cover_con" v-if="program.courseList && program.courseList.length">
                  <div class="video_cover">
                    <img :src="program.courseList[0].cover_url" class="cover" />
                  </div>
                  <div class="titleBox">
                    <div class="course_title">
                      <div class="cn">{{ program.courseList[0].name }}</div>
                      <div class="en">{{ program.courseList[0].name_en }}</div>
                    </div>
                  </div>
                </div>
                <div class="description">
                  <div class="text_cn" v-if="
                    program.courseList &&
                    program.courseList[0] &&
                    program.courseList[0].describe
                  ">
                    {{ program.courseList[0].describe }}
                  </div>
                  <div class="text_en" v-if="
                    program.courseList &&
                    program.courseList[0] &&
                    program.courseList[0].describe_en
                  ">
                    {{ program.courseList[0].describe_en }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="../img/chineseCultureVideoExhibition/2026/pc/footer.png" />
    </div>
    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay" @mousewheel.prevent>
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <div class="videoContainer">
            <video :src="currentVideoUrl" id="liveVideo" autoplay controls controlsList="nodownload"></video>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "chineseCultureVideoExhibition2026",
  metaInfo() {
    return {
      title: "2026魅力中文,中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content: "2026魅力中文,中央广播电视总台,精品节目展播",
        },
        {
          name: "description",
          content: "2026魅力中文 中央广播电视总台精品节目展播",
        },
      ],
    };
  },
  data: () => {
    return {
      isPlay: false,
      activeNavIndex: 0,
      subject_info: [],
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        speed: 500,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      rightContentOffsetTop: 0,
      CourseContainerOffsetTop: 0,
    };
  },
  methods: {
    //播放课程
    replay(url, cover) {
      this.currentVideoUrl = url;
      this.imgUrl = cover;
      this.isPlay = true;
      setTimeout(function () {
        //为video添加禁止右键另存为操作
        $("#liveVideo").bind("contextmenu", function () {
          return false;
        });
      }, 50);
    },
    closeVideo() {
      var myvideo = document.getElementById("liveVideo");
      if (!myvideo.paused) {
        //视频正在播放中时停止播放
        myvideo.pause();
      }
      this.isPlay = false;
    },
    goDetail(item, i) {
      this.$router.push({
        path: "/pcpage/cmgp2026_detail",
        query: {
          collection_id: item.id,
          videoIndex: i
        }
      });
    },
    updateSwipers() {
      const refs = this.$refs.mySwiper;
      if (!refs) return;
      if (Array.isArray(refs)) refs.forEach(r => r && r.swiper && r.swiper.update && r.swiper.update());
      else if (refs.swiper && refs.swiper.update) refs.swiper.update();
    },
    getCollectList() {
      this.$utils.get("/subject/lesson_Collection/getlist", {
        limit: 999,
        alias: 'cmgp2026',
      })
        .then((res) => {
          if (res.data.success) {
            this.subject_info = res.data.data.list
            this.getAllInfo()
          }
        })
    },
    // 获取专题信息
    async getSubjectInfo(item) {
      await this.$utils
        .get("/subject/lesson/getlist", {
          collection_id: item.id,
          order: 'sort',
          limit: 30
        })
        .then((res) => {
          if (res.data.success) {
            item.courseList = res.data.data.list
            this.$forceUpdate()
          }
        })
        .catch((r) => {
          console.log(r);
        });
    },
    //获取后端专题数据
    async getAllInfo() {
      await Promise.all(this.subject_info.map(item => this.getSubjectInfo(item)));
      // 监听页面的滚动，确认课程索引的位置
      this.$nextTick(() => {
        this.updateSwipers();
        window.addEventListener('scroll', this.pageScroll, false);
      });
    },

    scrollToProgram(index) {
      if (index < 0) return;
      const CourseContainer = this.$refs.CourseContainer;
      if (!CourseContainer || !CourseContainer.children) return;
      const targetElement = CourseContainer.children[index];
      if (!targetElement) return;
      const scrollOptions = {
        behavior: 'smooth',
        block: 'start'
      };
      targetElement.scrollIntoView(scrollOptions);
    },
    pageScroll() {
      const CourseContainer = this.$refs.CourseContainer;
      const mainContent = this.$refs.mainContent;
      if (!CourseContainer || !mainContent) return;
      // 存储数据，避免重复获取引起的性能问题
      if (this.mainContentOffsetTop === undefined) {
        this.mainContentOffsetTop = mainContent.offsetTop;
        this.CourseContainerOffsetTop = CourseContainer.offsetTop;
        this.cachedItemHeights = Array.from(CourseContainer.children).map(item => item.offsetHeight);
        this.cumulativeHeights = [];
        let sum = 0;
        this.cachedItemHeights.forEach(height => {
          sum += height;
          this.cumulativeHeights.push(sum);
        });
      }
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const scrollDistance = scrollTop - this.CourseContainerOffsetTop - this.mainContentOffsetTop;
      if (scrollDistance < 0) {
        this.activeNavIndex !== 0 && (this.activeNavIndex = 0);
        return;
      }

      let targetIndex = -1;
      const { cumulativeHeights } = this;
      let low = 0, high = cumulativeHeights.length - 1;
      while (low <= high) {
        const mid = (low + high) >> 1;
        if (cumulativeHeights[mid] > scrollDistance) {
          targetIndex = mid;
          high = mid - 1;
        } else {
          low = mid + 1;
        }
      }
      targetIndex = targetIndex === -1 ? cumulativeHeights.length - 1 : targetIndex;
      if (targetIndex !== this.activeNavIndex) {
        this.activeNavIndex = targetIndex;
      }
    },
  },
  created() {
    // 专题获取数据
    this.getCollectList()
  },
  mounted() {
    // 页面加载完滚动到顶部
    this.$nextTick(() => {
    });
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.pageScroll);
  },
};
</script>

<style scoped lang="scss">
.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100%;
  min-width: 1200px;
  user-select: none;
  background: #FFFCF6;

  .header_banner {
    position: relative;
    width: 100%;
    height: 640px;
    overflow: hidden;

    .banner_img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      object-position: center;
    }
  }

  .main_content {
    margin: -150px auto 0;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    gap: 0 68px;
  }

  .course_index {
    flex-shrink: 0;
    position: sticky;
    top: 80px;
    z-index: 1;
    padding-right: 28px;
    height: fit-content;
    border-right: 1px solid #B2C6CD;
    display: flex;
    flex-flow: column nowrap;
    gap: .125rem;

    .index_item {
      width: 165px;
      position: relative;
      cursor: pointer;

      p {
        position: relative;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        text-align: right;
        color: #364347;
        z-index: 2;

        &.name_en {
          z-index: 1;
          margin-top: -10px;
          word-break: break-word;
          font-family: DINCond-Medium;
          font-weight: 500;
          font-size: 12px;
          color: #93A4AA;
        }
      }

      &.active {
        &::after {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate(calc(100% + 9px), -50%);
          display: inline-block;
          content: "";
          width: 55px;
          height: 21px;
          background-image: url('../img/chineseCultureVideoExhibition//2026/pc/nav_active.png');
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }

        p {
          color: #973F31;

          &.name_en {
            color: #973F31;
          }
        }
      }
    }
  }

  .right_content {
    flex-shrink: 1;
    width: 1190px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    gap: 38px 0;
  }

  .theme_intro {
    align-self: center;
    box-sizing: border-box;
    padding: 32px 47px 65px 45px;
    max-width: 1100px;
    background: url("../img/chineseCultureVideoExhibition/2026/pc/intro_banner.png") no-repeat center/100% 100%;

    .theme_intro_cn {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      line-height: 30px;
      text-align: start;
      text-transform: none;
      text-indent: 2em;
    }

    .theme_intro_en {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 24px;
      text-align: justify;
      letter-spacing: 0;
      word-break: break-word;
      text-transform: none;
    }
  }

  .core_content {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 20px 0;
  }

  .program_box {
    flex: 1;
    padding: 30px 0 0;

    .series_info {
      box-sizing: border-box;
      padding: 0 49px 0 45px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 17px;

      .cloud_con {
        padding-left: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: start;
        width: fit-content;
        height: 82px;
        background-image: url('../img/chineseCultureVideoExhibition/2026/pc/item_title_icon.png');
        background-repeat: no-repeat;
        background-position: left bottom;
        background-size: 136px 44px;
        position: relative;


        .serise_icon_con {
          width: fit-content;
          font-size: 0;
          border: 3px solid #FFFFFF;
          box-shadow: 0px 4px 5px 0px #00000033;
          border-radius: 10px;
          overflow: hidden;

          img {
            width: 54px;
            height: 54px;
            object-fit: cover;
          }
        }

        .name_con {
          margin-left: 15px;
          width: 350px;
          text-align: start;
          font-weight: 700;
          font-style: Bold;
          font-family: Microsoft YaHei;
          line-height: 24px;
          letter-spacing: 0;

          .cn {
            margin-top: 8px;
            font-size: 24px;
            color: #364347;
          }

          .en {
            margin-top: 5px;
            font-size: 16px;
            color: #93A4AA;
          }
        }
      }

      .look_detail_icon {
        cursor: pointer;
        margin-top: 28px;
        width: 243px;
        height: 35px;
        background-image: url('../img/chineseCultureVideoExhibition/2026/pc/item_detail_icon.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }

    .description {
      box-sizing: border-box;
      width: 100%;
      padding: 0 48px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      gap: 5px 0;
      font-family: Microsoft YaHei;
      font-weight: 400;
      text-align: justify;
      letter-spacing: 0;
      color: #7C869E;
      text-align: justify;

      .text_cn {
        font-size: 14px;
        line-height: 24px;
        text-transform: uppercase;
      }

      .text_en {
        font-size: 12px;
        line-height: 20px;
      }
    }

    .swiper_con {
      padding: 21px 48px 0;
      position: relative;

      .swiper-container {
        position: unset;
      }

      .swiper {
        .swiper-slide {
          width: 3.52rem !important;

          .swiperBox {
            overflow: hidden;
          }
        }

        .video_con {
          width: 100%;
          margin-right: 20px;

          .video_cover {
            width: 100%;
            height: 198px;
            overflow: hidden;
            position: relative;
            cursor: pointer;
            font-size: 0;
            background-color: #D9D9D9;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .titleBox {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            color: #fff;
            background: #00000099;
            text-align: start;
            z-index: 9;
            display: flex;
            align-items: flex-end;
            padding: 10px 15px;
            box-sizing: border-box;

            .course_title {
              width: 100%;
              font-weight: 400;

              .cn {
                font-size: 18px;
                line-height: 18px;
                margin-bottom: 3px;
              }

              .en {
                font-size: 14px;
                line-height: 18px;
              }
            }
          }
        }
      }

      .swiper-button-prev {
        background-image: url(../img/chineseCultureVideoExhibition/2026/prev.png);
        position: absolute;
        left: 0;
        top: 96px;
        width: 50px;
        height: 50px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        z-index: 10;
      }

      .swiper-button-next {
        background-image: url(../img/chineseCultureVideoExhibition/2026/next.png);
        position: absolute;
        right: 0;
        top: 96px;
        width: 50px;
        height: 50px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        z-index: 10;
      }
    }

    .simple_content {
      padding: 0 48px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 0 20px;

      .cover_con {
        position: relative;

        .video_cover {
          width: 352px;
          height: 198px;
          overflow: hidden;
          position: relative;
          cursor: pointer;
          font-size: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .titleBox {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          color: #fff;
          background: #00000099;
          text-align: start;
          z-index: 9;
          display: flex;
          align-items: flex-end;
          padding: 10px 15px;
          box-sizing: border-box;

          .course_title {
            width: 100%;
            font-weight: 400;

            .cn {
              font-size: 18px;
              line-height: 18px;
              margin-bottom: 3px;
            }

            .en {
              font-size: 14px;
              line-height: 18px;
            }
          }
        }
      }

      .description {
        box-sizing: border-box;
        width: 100%;
        padding: 0;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        gap: 6px 0;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: justify;
        letter-spacing: 0;
        color: #7C869E;

        .text_cn {
          font-size: 14px;
          line-height: 24px;
          text-transform: uppercase;
        }

        .text_en {
          width: 100%;
          height: 80px;
          overflow: hidden;
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }

  .footer {
    position: relative;
    z-index: 1;
    margin-top: -380px;
    width: 100%;

    img {
      width: 100%;
      height: auto;
      object-fit: contain;
    }
  }
}
</style>
